/**
 * ns.wow Charts
 * Facade class for public accessible core functionality.
 */
import ChartXDownloader from "./ChartXDownloader";
import ChartConfig from './ChartConfig'
import ChartSupport from './ChartSupport';

class Plugin {

	init() {

		ChartConfig.currentURL = new URL(window.location.href);
		ChartConfig.urlParams = new URLSearchParams(ChartConfig.currentURL.search);

	}

	initKeyFigureComparison() {

		// Check context configuration
		if (!("kfc-chart" in NSContext.plugins.charts.config)) {
			console.log('NSContext: Chart configuration not found.');
		}

		window.addEventListener('click', (event) => {
			let element = event.target;
			if (element.classList.contains('nhs-kfc-chart-select__toggle')) {
				return;
			}
			ChartSupport.closeAllChartSelectToggle();
		});

		window.addEventListener("keydown", (event) => {
			if (event.code === 'Escape') {
				ChartSupport.closeAllChartSelectToggle();
			}
		}, true);

		let chartContainer = document.querySelector(ChartConfig.KFC_CHART_HOLDER_SELECTOR);
		let chartId = chartContainer.dataset.chartid;
		let chartFileId = NSContext.plugins.charts.config[chartId].config.get.csvid;
		let chartExchange = NSContext.plugins.charts.config[chartId].config.get.exchange;
		ChartConfig.KFC_CHART_IS_INDEXED = NSContext.plugins.charts.config[chartId].config.get.indexed;
		let exchangeKey = chartExchange ? 'swap' : 'standard';
		let series = NSContext.plugins.charts.config[chartId].config.mapping[chartFileId][exchangeKey]['series'];
		let category = NSContext.plugins.charts.config[chartId].config.mapping[chartFileId][exchangeKey].category;


		// Configure chart actions
		let chartExportSelector = ChartConfig.setChartSelector(chartId, ChartConfig.KFC_EXPORT_SELECTOR);
		chartExportSelector.forEach((el) => {
			el.addEventListener("click", (e) => {
				let chartContainer = e.target.closest(ChartConfig.KFC_CHART_HOLDER_SELECTOR);
				let chartId = chartContainer.dataset.chartid;
				let chart = ChartConfig.getChart(chartId);
				let mode = el.dataset.mode;
				if (mode == 'print') {
					chart.print();
				}
				if (mode == 'png') {
					chart.exportChart(
						{
							scale: 2
						}
					);
				}
				if (mode == 'xls') {
					//chart.downloadCSV();
					//chart.downloadXLS();
					ChartXDownloader.addDownload(chartId);
				}
			});
		})


		// Configure / series chart select toggle (dropdown field)
		let chartSelectToggleSelector = ChartConfig.setChartSelector(chartId, ChartConfig.KFC_SELECT_TOGGLE_SELECTOR);
		chartSelectToggleSelector.forEach((el) => {
			el.addEventListener("click", (e) => {

				let toTog = el.dataset.toggle;
				if (el.classList.contains("checked")) {
					ChartSupport.removeClass(el, 'checked');
					ChartSupport.removeClass(document.querySelector(toTog), 'checked');
				} else {
					ChartSupport.closeAllChartSelectToggle();
					ChartSupport.addClass(el, 'checked');
					ChartSupport.addClass(document.querySelector(toTog), 'checked');
				}
			});
		});


		let chartCategoryCheckboxes = ChartConfig.setChartSelector(chartId, ChartConfig.KFC_SWITCH_CATEGORY_SELECTOR);
		let chartSeriesCheckboxes = ChartConfig.setChartSelector(chartId, ChartConfig.KFC_SWITCH_SELECTOR);

		// Show or hide chart category on click (dropdown field)
		chartCategoryCheckboxes.forEach((el) => {
			el.addEventListener("click", (e) => {
				let chartCategoryCheckboxes = ChartConfig.setChartSelector(chartId, ChartConfig.KFC_SWITCH_CATEGORY_SELECTOR);
				NSContext.plugins.charts.config[chartId].config.mapping[chartFileId][exchangeKey]['activeCategoryIndex'] = ChartSupport.getValueAllCheckedFromSelector(chartCategoryCheckboxes);
				let chartSeriesCheckboxes = ChartConfig.setChartSelector(chartId, ChartConfig.KFC_SWITCH_SELECTOR);
				NSContext.plugins.charts.config[chartId].config.mapping[chartFileId][exchangeKey]['activeSeriesIndex'] = ChartSupport.getValueAllCheckedFromSelector(chartSeriesCheckboxes);
				this.createKeyFigureComparisonChart(chartId);
			});
		});

		// Show or hide chart series on click (dropdown field)
		chartSeriesCheckboxes.forEach((el) => {
			el.addEventListener("click", (e) => {
				let chartCategoryCheckboxes = ChartConfig.setChartSelector(chartId, ChartConfig.KFC_SWITCH_CATEGORY_SELECTOR);
				NSContext.plugins.charts.config[chartId].config.mapping[chartFileId][exchangeKey]['activeCategoryIndex'] = ChartSupport.getValueAllCheckedFromSelector(chartCategoryCheckboxes);
				let chartSeriesCheckboxes = ChartConfig.setChartSelector(chartId, ChartConfig.KFC_SWITCH_SELECTOR);
				NSContext.plugins.charts.config[chartId].config.mapping[chartFileId][exchangeKey]['activeSeriesIndex'] = ChartSupport.getValueAllCheckedFromSelector(chartSeriesCheckboxes);
				this.createKeyFigureComparisonChart(chartId);
			});
		});

		this.createKeyFigureComparisonChart(chartId);

	}

	createKeyFigureComparisonChart(chartId) {

		let chartContainer = document.querySelector(ChartConfig.KFC_CHART_HOLDER_SELECTOR);
		let csvid = NSContext.plugins.charts.config[chartId].config.get.csvid;
		let exchange = NSContext.plugins.charts.config[chartId].config.get.exchange;
		let indexed = NSContext.plugins.charts.config[chartId].config.get.indexed;
		let view = NSContext.plugins.charts.config[chartId].config.get.view;
		let stacking = NSContext.plugins.charts.config[chartId].config.options.stacking;
		let yAxisTitle = indexed ? NSContext.plugins.charts.config[chartId].config.mapping[csvid].options.option_indexed_yaxis_title : NSContext.plugins.charts.config[chartId].config.mapping[csvid].options.option_yaxis_title;
		let yAxisTitleOpposite = indexed ? NSContext.plugins.charts.config[chartId].config.mapping[csvid].options.option_indexed_yaxis_title_opposite : NSContext.plugins.charts.config[chartId].config.mapping[csvid].options.option_yaxis_title_opposite;

		let series = exchange ? NSContext.plugins.charts.config[chartId].config.mapping[csvid].swap.series : NSContext.plugins.charts.config[chartId].config.mapping[csvid].standard.series;
		let activeSeriesIndex = exchange ? NSContext.plugins.charts.config[chartId].config.mapping[csvid].swap.activeSeriesIndex : NSContext.plugins.charts.config[chartId].config.mapping[csvid].standard.activeSeriesIndex;
		let categories = exchange ? NSContext.plugins.charts.config[chartId].config.mapping[csvid].swap.category : NSContext.plugins.charts.config[chartId].config.mapping[csvid].standard.category;
		let activeCategoryIndex = exchange ? NSContext.plugins.charts.config[chartId].config.mapping[csvid].swap.activeCategoryIndex : NSContext.plugins.charts.config[chartId].config.mapping[csvid].standard.activeCategoryIndex;

		let useSeries = JSON.parse(JSON.stringify(series))
		let useActiveSeriesIndex = JSON.parse(JSON.stringify(activeSeriesIndex));
		let useCategories = [];
		let useActiveCategoryIndex = JSON.parse(JSON.stringify(activeCategoryIndex));


		if (chartContainer == null || useSeries == null || useCategories == null) {
			console.log('Chart configuration is not valid. Check your ACF settings.');
			return;
		}

		useActiveCategoryIndex.forEach((index) => {
			useCategories.push(categories[index])
		});

		useSeries.forEach((el) => {
			el.data = [];
		});

		series.forEach((el, indexSeries) => {
			let firstActiveSeriesIndex;
			el.data.forEach((val, index) => {
				if (useActiveCategoryIndex.includes(index)) {
					useSeries[indexSeries].data.push(val);
				}
			});
		});
		if (indexed) {
			let _coreValue;
			useSeries.forEach((el, useSeriesIndex) => {

				el.data.forEach((val, dataIndex) => {
					if (dataIndex == 0) {
						_coreValue = val;
						el.data[dataIndex] = 100;

					} else {

						//alte formel
						//let delta = ((((val-_coreValue)/Math.abs(_coreValue))*100));
						let delta = (val * 100) / _coreValue;
						el.data[dataIndex] = delta;

					}
				});
			});
		}
		//this Table use for xlsx downloader
		ChartSupport.createChartTableHidden(chartId, useSeries, useCategories, useActiveSeriesIndex, useActiveCategoryIndex);

		if (view == "table") {
			ChartSupport.createChartTableView(chartId, useSeries, useCategories, useActiveSeriesIndex, useActiveCategoryIndex);
		} else {



			let chartOptions = {
				chart: {
					type: view,
					events: {
						redraw: function () {
						}
					}
				},
				credits: {
					enabled: false,
				},
				legend: {
					useHTML: true,
					labelFormatter: function() {
						return '<span>' + this.name + '</span>';
					}
				},
				exporting: {
					enabled: false
				},
				title: {
					text: ''
				},
				tooltip: {
					useHTML: true,
					formatter: function () {

						let currentMapping =  NSContext.plugins.charts.config[chartId].config.mapping[csvid];
						let footNoteAddition = NSContext.plugins.charts.config[chartId].config.get.exchange == 1 ? currentMapping.swap.series[this.series.index].label[this.point.index] : currentMapping.standard.series[this.series.index].label[this.point.index];

						if (indexed) {
							let currentValue = this.y;
							let icon = '';
							const delta = this.y - 100;
							switch (true) {
								case (delta > 0):
									icon = '∆ +';
									break;
								case (delta < 0):
									icon = '∇ ';
									break;
								default:
									icon = '';
							}
							if (delta == 0) {
								return this.key + '<br>' + this.series.name + ': ' + this.y + '%' + footNoteAddition;
							} else {
								//let label = (Math.round(( (this.y - 100) * 100) / 100));
								let label = (this.y - 100).toFixed(2)
								return this.key + '<br>' + this.series.name + ': ' + icon + label + '%' + footNoteAddition;

							}
						} else {
							let chartLocal = NSContext.plugins.charts.config[chartId].config.mapping[csvid].options.local;
							let toStringStyle = NSContext.plugins.charts.config[chartId].config.mapping[csvid].options.option_to_string_style;
							let toStringCurrency = NSContext.plugins.charts.config[chartId].config.mapping[csvid].options.option_to_string_currency_code;
							let styleOptions;
							switch (toStringStyle) {
								case 'currencySymbol':
									styleOptions = {
										style: "currency",
										currencyDisplay: "symbol",
										currency: toStringCurrency,
										useGrouping: true,
									};
									break;
								case 'currencyCode':
									styleOptions = {
										style: "currency",
										currencyDisplay: "code",
										currency: toStringCurrency,
										useGrouping: true,
									};
									break;
								case 'currencyName':
									styleOptions = {
										style: "currency",
										currencyDisplay: "name",
										currency: toStringCurrency,
										useGrouping: true,
									};
									break;
								case 'decimal':
									styleOptions = {
										style: "decimal",
										useGrouping: true,
									};
									break;
								case 'percent':
									styleOptions = {
										style: "percent",
										useGrouping: true,
									};
									break;
								case 'none':
									styleOptions = {
										useGrouping: false,
									};
									break;
							}

							return this.key + '<br>' + this.series.name + ': ' + this.y.toLocaleString(chartLocal, styleOptions) + footNoteAddition ;
						}
					}
				},
				xAxis: {
					categories: useCategories,
					labels: {
						useHTML: true
					}
				},
				series: useSeries,
				plotOptions:{
					series: {
						events: {
							legendItemClick: function(event) {
								if (this.visible) {
									ChartSupport.updateCheckboxAfterChangeSeriesHook(event.target.index,false);
								} else {
									ChartSupport.updateCheckboxAfterChangeSeriesHook(event.target.index,true);
								}
								return true;
							}
						}
					}
				}
			};


			if (yAxisTitle) {
				chartOptions.yAxis = [{
					title: {
						text: yAxisTitle,
						useHTML: true,
					},
					labels: {
						useHTML: true,
						formatter: function() {
							const defaultLabel = this.axis.defaultLabelFormatter.call(this);
							return '<span>' + defaultLabel + '</span>';
						}
					}
				}];
			}

			if (yAxisTitle && yAxisTitleOpposite) {
				chartOptions.yAxis = [{
					title: {
						useHTML: true,
						text: yAxisTitle
					},
					labels: {
						useHTML: true,
						formatter: function() {
							const defaultLabel = this.axis.defaultLabelFormatter.call(this);
							return '<span>' + defaultLabel + '</span>';
						}
					},
				}, {
					title: {
						text: yAxisTitleOpposite,
						useHTML: true,
					},
					labels: {
						useHTML: true,
						formatter: function() {
							const defaultLabel = this.axis.defaultLabelFormatter.call(this);
							return '<span>' + defaultLabel + '</span>';
						}
					},
					opposite: true
				}];
			}

			if (stacking !== 'undefined' && view !== 'line') {
				chartOptions.plotOptions.series = Highcharts.merge(chartOptions.plotOptions.series, {
					stacking: stacking
				});

			}

			let chartConfigs = NSCore.applyFilters('nswow_charts_kfc_options', chartOptions);

			let chart = Highcharts.chart('chartContainer', chartConfigs);


			let chartSeriesCheckboxes = ChartConfig.setChartSelector(chartId, ChartConfig.KFC_SWITCH_SELECTOR);
			let chartSeriesCheckboxesChecked = ChartSupport.getValueAllCheckedFromSelector(chartSeriesCheckboxes);
			let activeSeriesIndex = [];

			chartSeriesCheckboxesChecked.forEach((value, index) => {
				activeSeriesIndex[index] = parseInt(value);
			});

			chart.series.forEach((element, index) => {
				let findIndex = activeSeriesIndex.find(item => item == index);

				if (findIndex !== undefined) {
					chart.series[index].show();
				} else {
					chart.series[index].hide();
				}
			});

			ChartConfig.setChart(chartId, chart);

		}

	}

}

export default new Plugin();
